import { Github, ArrowUpRight, User } from "lucide-react";
import { Link } from "react-router-dom";
import { BrandMark, BrandText } from "./BrandLogo";

export function Footer() {
  return (
    <footer className="mt-auto border-t border-border/50 py-5">
      <div className="container flex flex-col items-center gap-4 md:flex-row md:justify-between">
        <div className="flex items-center gap-2.5">
          <BrandMark className="h-5 w-5 opacity-60" />
          <BrandText className="opacity-60" />
          <span className="font-mono text-[10px] text-muted-foreground/60 ml-1">v7.0</span>
        </div>

        <div className="flex items-center gap-3 font-mono text-[11px] text-muted-foreground">
          <Link to="/privacy" className="hover:text-foreground transition-colors duration-200">Privacy</Link>
          <span className="text-border">|</span>
          <Link to="/terms" className="hover:text-foreground transition-colors duration-200">Terms</Link>
        </div>

        <div className="flex items-center gap-3 font-mono text-[11px] text-muted-foreground">
          <a
            href="https://github.com/m4xx101"
            className="inline-flex items-center gap-1.5 hover:text-foreground transition-colors duration-200"
            target="_blank"
            rel="noreferrer"
          >
            <Github className="h-3.5 w-3.5" aria-hidden />
            m4xx101
            <ArrowUpRight className="h-2.5 w-2.5 opacity-40" />
          </a>
          <span className="text-border">|</span>
          <a
            href="https://portfolio.m4xx.cfd"
            className="inline-flex items-center gap-1.5 hover:text-foreground transition-colors duration-200"
            target="_blank"
            rel="noreferrer"
          >
            <User className="h-3.5 w-3.5" aria-hidden />
            Portfolio
            <ArrowUpRight className="h-2.5 w-2.5 opacity-40" />
          </a>
          <span className="text-border">|</span>
          <span className="inline-flex items-center gap-1 border border-border/50 rounded-full px-2 py-0.5 text-[10px] text-muted-foreground/70">
            AGPL-3.0
          </span>
        </div>
      </div>
    </footer>
  );
}
